import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, TransitionGroup as _TransitionGroup, vShow as _vShow, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76c87874"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-word" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "head-wrap" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "単語の編集")
], -1))
const _hoisted_4 = { class: "tab" }
const _hoisted_5 = { class: "tool-wrap" }
const _hoisted_6 = { class: "filter" }
const _hoisted_7 = { class: "save" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "save", -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode("変更の保存")
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "search-tool" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "word-wrap" }
const _hoisted_15 = { class: "word-list-wrap" }
const _hoisted_16 = { style: {"padding":"5px","font-size":"12px"} }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "word" }
const _hoisted_19 = {
  key: 0,
  class: "update-tool"
}
const _hoisted_20 = { class: "input-wrap" }
const _hoisted_21 = { class: "info" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = {
  key: 1,
  class: "change-tool"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "delete_outline", -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = {
  key: 0,
  class: "word-input-wrap"
}
const _hoisted_29 = { class: "word-input" }
const _hoisted_30 = { class: "mods" }
const _hoisted_31 = {
  key: 1,
  class: "word-view-wrap"
}
const _hoisted_32 = { class: "word-view" }
const _hoisted_33 = { class: "mods" }
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" 助詞： ")
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { class: "tab" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  height: "24",
  viewBox: "0 0 24 24",
  width: "24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }),
  /*#__PURE__*/_createElementVNode("path", { d: "M4 10.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-6c-.83 0-1.5.67-1.5 1.5S3.17 7.5 4 7.5 5.5 6.83 5.5 6 4.83 4.5 4 4.5zm0 12c-.83 0-1.5.68-1.5 1.5s.68 1.5 1.5 1.5 1.5-.68 1.5-1.5-.67-1.5-1.5-1.5zM7 19h14v-2H7v2zm0-6h14v-2H7v2zm0-8v2h14V5H7z" })
], -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "単語一覧", -1))
const _hoisted_41 = [
  _hoisted_39,
  _hoisted_40
]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  height: "24px",
  viewBox: "0 0 24 24",
  width: "24px",
  fill: "#000000"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }),
  /*#__PURE__*/_createElementVNode("path", { d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" })
], -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "単語登録", -1))
const _hoisted_44 = [
  _hoisted_42,
  _hoisted_43
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal = _resolveComponent("modal")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_word_editor = _resolveComponent("word-editor")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_modal, {
      header: "新規カテゴリ登録",
      show: _ctx.state.showModal,
      onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.showModal=false))
    }, {
      content: _withCtx(() => [
        _withDirectives(_createElementVNode("input", {
          class: "input-1",
          type: "text",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.category) = $event))
        }, null, 512), [
          [_vModelText, _ctx.state.category]
        ]),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addCategory && _ctx.addCategory(...args)), ["stop","prevent"]))
        }, "登録")
      ]),
      _: 1
    }, 8, ["show"]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", {
        class: _normalizeClass(["tab-wrap", {'adjust-height':_ctx.state.tabIndex==1}])
      }, [
        _createElementVNode("div", {
          class: "tabs",
          style: _normalizeStyle({height:_ctx.state.vh-110+'px'})
        }, [
          _withDirectives(_createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _withDirectives(_createElementVNode("input", {
                  class: "filter-input",
                  type: "text",
                  placeholder: "文字検索",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.searchText) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.state.searchText]
                ]),
                _createElementVNode("div", _hoisted_7, [
                  (!_ctx.saveLoading)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
                      }, _hoisted_10))
                    : (_openBlock(), _createElementBlock("p", _hoisted_11, "更新中"))
                ])
              ]),
              _createElementVNode("div", {
                class: "scroll",
                onMousewheelPassive: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.mouseWheel && _ctx.mouseWheel(...args)))
              }, [
                _createElementVNode("ul", _hoisted_12, [
                  _createElementVNode("li", {
                    class: _normalizeClass({active:_ctx.state.searchCats.includes(-1)}),
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.search(-1)))
                  }, "自分の", 2),
                  _createElementVNode("li", {
                    class: _normalizeClass({active:_ctx.state.searchCats.includes(-2)}),
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.search(-2)))
                  }, "有効", 2),
                  _createElementVNode("li", {
                    class: _normalizeClass({active:_ctx.state.searchCats.includes(-3)}),
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.search(-3)))
                  }, "無効", 2),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (cat) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: _normalizeClass({active:_ctx.state.searchCats.includes(cat.id)}),
                      onClick: ($event: any) => (_ctx.search(cat.id)),
                      key: cat.id
                    }, _toDisplayString(cat.name), 11, _hoisted_13))
                  }), 128))
                ])
              ], 32)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("p", _hoisted_16, "表示数：" + _toDisplayString(_ctx.filterWords.length), 1),
                _createVNode(_TransitionGroup, {
                  tag: "ul",
                  name: "list",
                  mode: "out-in",
                  class: "word-list"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterWords, (word) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: word.id,
                        onClick: ($event: any) => (_ctx.state.currentWord = word),
                        class: _normalizeClass({
                      current: _ctx.state.currentWord.id == word.id,
                      editable: word.author.uuid == _ctx.user.uuid,
                      delete: _ctx.state.delWords.includes(Number(word.id)),
                      update: _ctx.state.editWords.find(x=>x.id==word.id),
                      error: _ctx.trim(word.word).length == 0 || word.categories.length == 0
                    })
                      }, [
                        _createElementVNode("p", _hoisted_18, _toDisplayString(word.word), 1)
                      ], 10, _hoisted_17))
                    }), 128))
                  ]),
                  _: 1
                })
              ])
            ]),
            (_ctx.state.currentWord.author)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("p", null, [
                        _createTextVNode(_toDisplayString(_ctx.format(_ctx.state.currentWord.updatedAt)), 1),
                        _createElementVNode("span", null, "：" + _toDisplayString(_ctx.state.currentWord.author.nickname), 1)
                      ]),
                      (_ctx.state.currentWord.author.uuid != _ctx.user.uuid)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                            (_ctx.state.currentWord.active)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_23, "有効"))
                              : (_openBlock(), _createElementBlock("p", _hoisted_24, "無効"))
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_25, [
                            _createElementVNode("div", {
                              class: "trash",
                              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.delWord && _ctx.delWord(...args)))
                            }, _hoisted_27),
                            _createElementVNode("div", {
                              class: _normalizeClass({'btn-toggle':true,active:_ctx.state.currentWord.active}),
                              onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.toggleActive && _ctx.toggleActive(...args)))
                            }, null, 2)
                          ]))
                    ]),
                    (_ctx.state.currentWord.author.uuid==_ctx.user.uuid)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                          _createElementVNode("div", _hoisted_29, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.currentWord.word) = $event)),
                              onInput: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.inputWord && _ctx.inputWord(...args)))
                            }, null, 544), [
                              [_vModelText, _ctx.state.currentWord.word]
                            ])
                          ]),
                          _createElementVNode("ul", _hoisted_30, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.currentWord.mods, (mod, index) => {
                              return (_openBlock(), _createElementBlock("li", {
                                class: "mod",
                                key: index
                              }, [
                                _createVNode(_component_a_input, {
                                  modelValue: mod.mod,
                                  "onUpdate:modelValue": ($event: any) => ((mod.mod) = $event),
                                  "max-length": "10",
                                  onInput: _ctx.modChange
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                              ]))
                            }), 128)),
                            _createElementVNode("li", {
                              class: "add-mod",
                              onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.addMod && _ctx.addMod(...args)))
                            }, "+")
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_31, [
                          _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.state.currentWord.word), 1),
                          _createElementVNode("div", _hoisted_33, [
                            _hoisted_34,
                            (_ctx.state.currentWord.mods && _ctx.state.currentWord.mods.length)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_35, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.currentWord.mods, (mod) => {
                                    return (_openBlock(), _createElementBlock("span", {
                                      class: "sub",
                                      key: mod.id
                                    }, _toDisplayString(mod.mod), 1))
                                  }), 128))
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_36, "なし"))
                          ])
                        ])),
                    _createElementVNode("div", {
                      class: "scroll-wrap",
                      onMousewheelPassive: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.mouseWheel && _ctx.mouseWheel(...args)))
                    }, [
                      _createElementVNode("ul", {
                        class: _normalizeClass(["categories", {active:_ctx.state.currentWord.author.uuid == _ctx.user.uuid}])
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (cat) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: cat.id,
                            class: _normalizeClass({ pick: _ctx.pick(cat.id) }),
                            onClick: ($event: any) => (_ctx.toggleCategory(cat))
                          }, _toDisplayString(cat.name), 11, _hoisted_37))
                        }), 128)),
                        _createElementVNode("li", {
                          class: "add-category",
                          onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.state.showModal=true))
                        }, "+")
                      ], 2)
                    ], 32)
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 512), [
            [_vShow, _ctx.state.tabIndex == 0]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_38, [
            _createVNode(_component_word_editor, {
              ref: "editorRef",
              allCategories: _ctx.categories
            }, null, 8, ["allCategories"])
          ], 512), [
            [_vShow, _ctx.state.tabIndex == 1]
          ])
        ], 4),
        _createElementVNode("ul", {
          class: "tab-btns",
          onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.tabClick && _ctx.tabClick(...args)))
        }, [
          _createElementVNode("li", {
            "data-id": "0",
            class: _normalizeClass({ current: _ctx.state.tabIndex == 0 })
          }, _hoisted_41, 2),
          _createElementVNode("li", {
            "data-id": "1",
            class: _normalizeClass({
              current: _ctx.state.tabIndex == 1,
            })
          }, _hoisted_44, 2),
          _createElementVNode("li", {
            class: "hover",
            style: _normalizeStyle({ transform: `translateX(${100 * _ctx.state.tabIndex}%)` })
          }, null, 4)
        ])
      ], 2)
    ])
  ]))
}